module.exports = __webpack_public_path__ + "img/cat-dog.0c653c18.svg";